/*  ========================================================================
    # Sections - Posts - Post Card
    ========================================================================  */

import React from 'react';
import { type MappedPost } from '@/react/hooks/usePostsApi';

export const PostCardSkeleton = () => {
  return (
    <div className='c-post-card c-post-card--skeleton'>
      <div />
      <div>
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export const PostCard = ({ permalink, image, category, title, excerpt }: MappedPost) => {
  const truncateExcerpt = (excerpt: string, maxLength = 120): string => {
    if (excerpt.length <= maxLength) return excerpt;

    const truncated = excerpt.substring(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');

    return truncated.substring(0, lastSpace) + '...';
  };

  return (
    <a className='c-post-card' href={permalink}>
      <figure className='c-post-card__image'>
        {image.sizes ? (
          <img src={image.sizes?.large} alt={image.alt} />
        ) : null}
      </figure>
      <div className='c-post-card__content' style={{ backgroundColor: category.accentColorLight ?? '#C3DDEF' }}>
        <span style={{ backgroundColor: category.accentColorDark ?? '#3E92CC' }}>{category.name}</span>
        <div className='c-post-card__content-body'>
          <h3 className='h4' dangerouslySetInnerHTML={{ __html: title }} />
          <p dangerouslySetInnerHTML={{ __html: truncateExcerpt(excerpt) }} />
        </div>
        <strong>Read More</strong>
      </div>
    </a>
  );
};
